
//Dependencies
import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

//material-ui
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { MuiPickersUtilsProvider, InlineDatePicker } from 'material-ui-pickers';
import Info from '@material-ui/icons/InfoOutlined';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import InputAdornment from '@material-ui/core/InputAdornment';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContentWrapper from './../../Global/SnackbarContentWrapper';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import MomentUtils from '@date-io/moment';
import "moment/locale/es";

//Assets

// persistencia en redux
import { connect } from 'react-redux';
import { store } from '../../../store/configure';
import { setLandingPage } from '../../../actions/actions';

class Simulacion extends Component {
    constructor(props) {
        super(props);
        moment.locale('esp');
        this.parametria = {};
        this.state = {
            locale: 'es',
            plazoDias: moment(),
            plazo: "",
            monto: "",
            montoMin: 0,
            montoMax: 0,
            plazoMin: 0,
            plazoMax: 0,
            tna: 0,
            capital: 0,
            interes: 0,
            fechaVencimiento: "",
            open: false,
            errorPlazoFinDeSemana:false,
            toDisabledSimular:true,
            tipoPlazoFijo:1,
            cotizacionUva:"",
            montoInicialUva:"",
            tipoPlazoFijo:1,
            tiposPlazoFijo:[
                {id:1,descripcion:"Tradicional en pesos"},
                {id:2,descripcion:"Ajustable por UVA Precancelable"}
            ]
        };

        const persistData = {
            type: 'INFORMACION_DOMICILIO',
            data: this.state,
        }
        store.dispatch(
            setLandingPage(persistData)
        )
        this.simulacion = this.simulacion.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.redireccionarHomeBanking = this.redireccionarHomeBanking.bind(this);
        this.toDisabledSimular = this.toDisabledSimular.bind(this)
        this.isWeekend = this.isWeekend.bind(this)
        this.getDiasMinimos = this.getDiasMinimos.bind(this)
        this.getDiasMaximo = this.getDiasMaximo.bind(this)
        this.handleChangeDateParamThreshold = this.handleChangeDateParamThreshold.bind(this)
        
    }

    isWeekend(event) {
        const fecha = event;
        return fecha.day() === 0 || fecha.day() === 6;
    }

    snackbar = () => {
        this.setState({ open: true });
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ open: false });
    };

    componentWillReceiveProps(nextProps){

        let { parametria } = nextProps.dataLanding
        //se obtuvo
        if( parametria !== "undefined" && Object.keys(parametria).length > 0){
            //chequeo q justo no caiga en un fin de semana
            this.parametria = parametria;
            
            let minPlzo = Number(parametria.plazoMinimoSimulacion)
            let aMoment = moment().add(Number(parametria.plazoMinimoSimulacion), 'days')
            if(this.isWeekend(aMoment)){
                aMoment = aMoment.add(1,'days')
                minPlzo++
            }
            //cayo en domingo
            if(this.isWeekend(aMoment)){
                aMoment = aMoment.add(1,'days')
                minPlzo++
            }

            this.setState({
                montoMin: Number(parametria.montoMinimoSimulacion),
                montoMax: Number(parametria.montoMaximoSimulacion),
                plazoMin: Number(parametria.plazoMinimoSimulacion),
                plazoMax: Number(parametria.plazoMaximoSimulacion),
                tna: Number(parametria.tna).toFixed(2),
                plazoDias : aMoment.format("YYYY-MM-DD"),
                plazo : minPlzo++
            });
        }        
    }
    
    //REFACTORIZAR
    handleChange = event => {
        if (event.target.name === 'plazo') {

            var date = new Date();
            var dayWrapper = moment(date);
            var fechaSimulacion = dayWrapper.add(event.target.value , 'day')

            this.setState({
                fechaVencimiento: fechaSimulacion,
                plazo: event.target.value,
                plazoDias: fechaSimulacion.format("YYYY-MM-DD")
            });    
        } else {
            if( event.target.name === 'monto' ){
                this.setState({
                    monto: event.target.value
                });
            }else{
                let {plazo,monto,montoMin,tna, plazoDias} = this.state

                if(event.target.value === 2){
                    if(plazo < this.props.dataLanding.parametriaUvas.plazoMin){
                        montoMin = this.props.dataLanding.parametriaUvas.montoMin
                        plazo = this.props.dataLanding.parametriaUvas.plazoMin
                        tna = this.props.dataLanding.parametria.tnaUVA
                        plazoDias = moment().add(Number(plazo), 'days').format("YYYY-MM-DD")
                    }
                }else{
                    //PF tradicional
                    tna =  Number(this.props.dataLanding.parametria.tna).toFixed(2);
                    plazo = this.parametria.plazoMinimoSimulacion
                    plazoDias = moment().add(Number(plazo), 'days').format("YYYY-MM-DD")
                    montoMin =  Number(this.parametria.montoMinimoSimulacion)
                }

                this.setState({
                    tipoPlazoFijo: event.target.value,
                    plazo,
                    plazoDias,
                    montoMin,
                    cotizacionUva:"",
                    montoInicialUva:"",
                    monto,
                    interes:0,
                    tna,
                    capital:0
                });
            }
        }
    }

    isWeekend(event) {
        const fecha = event;
        return fecha.day() === 0 || fecha.day() === 6;
    }

    //se crea en cada render REFACTORIZAR
    handleChangeDateParamThreshold(diasMinimosPlazoFijo,diasMaximoPlazoFijo) {
        return event => {

            let dias = event.diff(moment(), 'days') + 1;
            this.setState({ 
                plazoDias: event , 
                plazo: dias,
                errorPlazo: dias < diasMinimosPlazoFijo || dias >= diasMaximoPlazoFijo
            });
            
        }
    }

    

    simulacion = (event) => {
        event.preventDefault();
        $(".load").fadeIn(700);

        let tipo = (this.state.tipoPlazoFijo === 1)? "PESOS" : "UVAS" 
        let plazo = this.state.plazo

        let data = {
            monto: this.state.monto,
            plazo,
            tipo
        }

        axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            data,
            url: localStorage.getItem('url') + '/api/plazoFijo/simular'
        },{withCredentials: true}).then((response) => {
            if (response.status === 200) {
                var simulacion = response.data;
                
                let newState = {
                    tna: Number(simulacion.tasa),
                    interes: Number(simulacion.totalInteresEstimado),
                    capital: Number(simulacion.totalInteresEstimado) + Number(simulacion.capital),
                    fechaVencimiento: simulacion.fechaVencimiento,
                    plazo
                }

                if( this.state.tipoPlazoFijo === 2 ){
                    newState = {
                        ...newState,
                        cotizacionUva: response.data.cotizacionUVA,
                        montoInicialUva:  response.data.montoUVA,
                        tnaCancelacionAnt:  response.data.tnaCancelacionAnt,
                        teaCancelacionAnt:  response.data.teaCancelacionAnt
                    }
                }

                let persistData = {
                    type: 'LANDING_PAGE',
                    data: {
                        ...this.state,
                        ...newState,
                        plazo
                    }
                }
                
                store.dispatch(
                    setLandingPage(persistData)
                )

                this.setState(newState);
            }

            $(".load").fadeOut(700);
        }).catch(error => {
            $(".load").fadeOut(700);
            this.snackbar()
        });
        
    }
    redireccionarHomeBanking() {
        window.location.replace('https://hb.hipotecario.com.ar/');
    }

    toDisabledSimular(){
        let { plazo, monto, montoMin, montoMax, plazoDias} = this.state

        let plazoMin = this.getDiasMinimos()
        let plazoMax = this.getDiasMaximo() 

        if( plazo === "" || monto === "" ){
            return true
        }
            
        let montoOk =  monto >= montoMin && monto <= montoMax 
        let plazoOk =  plazo >= plazoMin && plazo <= plazoMax && !this.isWeekend(moment(plazoDias))
        
        return !montoOk || !plazoOk
    }

    getDiasMinimos(){
        if(this.state.tipoPlazoFijo === 2)
            return this.props.dataLanding.parametriaUvas.plazoMin

        return this.props.dataLanding.parametria.plazoMinimoSimulacion
    }
    getDiasMaximo(){
        if(this.state.tipoPlazoFijo === 2)
            return this.props.dataLanding.parametriaUvas.plazoMax

        return this.props.dataLanding.parametria.plazoMaximoSimulacion
    }

    render() {
        if( Object.keys(this.props.dataLanding.parametria).length === 0){
            return null
        }

        let diasMinimosPlazoFijo = this.getDiasMinimos()
        let diasMaximoPlazoFijo = this.getDiasMaximo()

        const { classes } = this.props;
        const mensajePickerPlazoMinimo = `El plazo mínimo para un plazo fijo es de ${diasMinimosPlazoFijo} días`;
        const mensajePickerPlazoMaximo = `El plazo máximo para un plazo fijo es de ${diasMaximoPlazoFijo} días`;
        
        
        let mensajeFechaFinDeSemana = "",errorPlazoFinDeSemana=false
        if( this.isWeekend(moment(this.state.plazoDias)) ){
            errorPlazoFinDeSemana = true
            mensajeFechaFinDeSemana = "no puede seleccionar un fin de semana"
        }

        let toDisabledSimular = this.toDisabledSimular()

        let showDetalleUva = ( this.state.tipoPlazoFijo === 2 && this.state.cotizacionUva !== "" ) ?"":"none"

        return (
            <div className="simulacion" >
                <Grid container className="simulacion-container">
                    <Grid item xs={12} className="description-title">
                        Simulá tu Plazo Fijo
                    </Grid>
                    <Grid item xs={12} className="description-text">
                        Ingresá cuánto querés invertir y calculá el monto a recibir.
                    </Grid>
                    <Grid item xs={12}>
                        <Card className={classes.card + " card-simulacion "}>
                            <ValidatorForm
                                ref="form"
                                onSubmit={this.simulacion}>
                                <CardContent>
                                    <div className={classes.margin}>
                                        <Grid container spacing={8} alignItems="center" className="form-container">
                                            <Grid item xs={1} className={classes.iconmatch}>
                                            </Grid>
                                            <Grid item xs={11} className="input-simulacion" >
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="tipoPlazoFijo">Tipo</InputLabel>
                                                    <Select
                                                        style={{textAlign:"left"}}
                                                        fullWidth
                                                        onChange={this.handleChange}
                                                        validators={['required']}
                                                        value={this.state.tipoPlazoFijo}
                                                        inputProps={{
                                                            name: 'tipoPlazoFijo',
                                                            id: 'tipoPlazoFijo',
                                                            name: 'tipoPlazoFijo'
                                                        }}
                                                    >
                                                        {
                                                            this.state.tiposPlazoFijo.map((versionDocumento, key) => (
                                                                <MenuItem key={key} value={versionDocumento.id}>
                                                                    {versionDocumento.descripcion}
                                                                </MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={8} alignItems="center" className="form-container">
                                            <Grid item xs={1} className={classes.iconmatch}>
                                                <SvgIcon viewBox='0 0 30 30'>
                                                    <path d="M14.015 19.33h-1.723a1.131 1.131 0 0 1-1.134-1.13c0-.623.508-1.128 1.134-1.128h3.032a.752.752 0 0 0 .752-.749.752.752 0 0 0-.752-.748h-1.422v-1.042a.752.752 0 0 0-1.503 0v1.042h-.107A2.636 2.636 0 0 0 9.654 18.2a2.636 2.636 0 0 0 2.638 2.625h1.723c.626 0 1.134.506 1.134 1.13 0 .623-.508 1.128-1.134 1.128h-3.089a.752.752 0 0 0-.752.749c0 .411.339.748.752.748h1.479v1.067a.752.752 0 0 0 1.503 0V24.58h.145a2.632 2.632 0 0 0 2.6-2.626 2.636 2.636 0 0 0-2.638-2.625z" />
                                                    <path d="M24.453 17.633c-.79-1.809-1.88-3.561-3.258-5.202-1.667-1.995-3.327-3.33-4.173-3.948l3.195-5.9a.736.736 0 0 0-.137-.885C19.253.893 18.375.5 17.398.5c-.896 0-1.717.337-2.43.636-.565.23-1.097.455-1.53.455a.956.956 0 0 1-.357-.062C11.591.986 10.444.65 9.335.65c-1.403 0-2.6.562-3.772 1.76a.75.75 0 0 0-.087.935L8.92 8.527a24.633 24.633 0 0 0-4.116 3.904c-1.372 1.64-2.468 3.393-3.258 5.202-.99 2.277-1.49 4.653-1.49 7.06 0 3.2 2.618 5.807 5.832 5.807h14.222c3.214 0 5.833-2.607 5.833-5.807 0-2.407-.502-4.783-1.491-7.06zM7.08 3.033c.726-.624 1.422-.899 2.255-.899.89 0 1.892.3 3.226.792.276.1.57.15.871.15.733 0 1.435-.287 2.105-.568.646-.268 1.26-.524 1.855-.524.288 0 .695.05 1.209.412l-3.007 5.563h-5.238L7.08 3.032zm13.03 25.97H5.89c-2.388 0-4.33-1.933-4.33-4.31 0-3.998 1.472-7.79 4.367-11.27a22.96 22.96 0 0 1 4.254-3.967h5.626c.57.393 2.424 1.765 4.254 3.967 2.9 3.48 4.366 7.266 4.366 11.27.013 2.377-1.93 4.31-4.316 4.31z" />
                                                </SvgIcon>
                                            </Grid>
                                            <Grid item xs={11} className="input-simulacion" >
                                                <TextValidator type="number" required
                                                    validators={['minNumber:' + this.state.montoMin, 'maxNumber:' + this.state.montoMax, 'required', 'isNumber', 'isPositive']}
                                                    errorMessages={['Monto mínimo $' + this.state.montoMin.toLocaleString(), 'Monto maximo $' + this.state.montoMax.toLocaleString(), 'El campo monto es requerido', "Solo puedes ingresar numeros", "Solo puedes ingresar numeros"]}
                                                    fullWidth
                                                    id="monto"
                                                    name="monto"
                                                    label="Monto"
                                                    helperText={"Mínimo $" + this.state.montoMin }
                                                    value={this.state.monto}
                                                    onChange={this.handleChange}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        className: classes.fechaLabel
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.montoPlazoFechaLabel
                                                    }}
                                                    FormHelperTextProps={{
                                                        className: classes.montoPlazoFechaHelperText
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={8} className="form-container">
                                            <Grid item xs={1} className={classes.calendarIconCenter}>
                                                <SvgIcon viewBox='0 0 30 30'>
                                                    <path d="M23.715 3.547h-.762v-.762A2.288 2.288 0 0 0 20.668.5a2.288 2.288 0 0 0-2.285 2.285v.762h-3.047v-.762A2.288 2.288 0 0 0 13.05.5a2.288 2.288 0 0 0-2.285 2.285v.762H7.617v-.762A2.288 2.288 0 0 0 5.332.5a2.288 2.288 0 0 0-2.285 2.285v.762h-.762A2.288 2.288 0 0 0 0 5.832v18.383A2.288 2.288 0 0 0 2.285 26.5h21.43A2.288 2.288 0 0 0 26 24.215V5.832a2.288 2.288 0 0 0-2.285-2.285zm-3.809-.762a.763.763 0 0 1 1.524 0v3.047a.763.763 0 0 1-1.524 0V2.785zm-7.617 0a.763.763 0 0 1 1.524 0v3.047a.763.763 0 0 1-1.524 0V2.785zm-7.719 0a.763.763 0 0 1 1.524 0v3.047a.763.763 0 0 1-1.524 0V2.785zm19.907 21.43c0 .42-.342.762-.762.762H2.285a.763.763 0 0 1-.762-.762v-12.95h22.954v12.95zm0-14.473H1.523v-3.91c0-.42.342-.762.762-.762h.762v.762a2.288 2.288 0 0 0 2.285 2.285 2.288 2.288 0 0 0 2.285-2.285V5.07h3.149v.762a2.288 2.288 0 0 0 2.285 2.285 2.288 2.288 0 0 0 2.285-2.285V5.07h3.047v.762a2.288 2.288 0 0 0 2.285 2.285 2.288 2.288 0 0 0 2.285-2.285V5.07h.762c.42 0 .762.342.762.762v3.91z" />
                                                    <path d="M22.191 12.79H3.81a.762.762 0 0 0-.762.76v9.141c0 .421.34.762.762.762H22.19c.421 0 .762-.34.762-.762v-9.14a.762.762 0 0 0-.762-.762zM7.617 21.93H4.57v-3.047h3.047v3.047zm0-4.57H4.57v-3.047h3.047v3.046zm4.672 4.57H9.141v-3.047h3.148v3.047zm0-4.57H9.141v-3.047h3.148v3.046zm4.57 4.57h-3.047v-3.047h3.047v3.047zm0-4.57h-3.047v-3.047h3.047v3.046zm4.57 4.57h-3.046v-3.047h3.047v3.047zm0-4.57h-3.046v-3.047h3.047v3.046z" />
                                                </SvgIcon>
                                            </Grid>
                                            <Grid item xs={11} sm={11} md={5} className="input-simulacion">
                                                <TextValidator type="number" required
                                                    validators={['minNumber:' + diasMinimosPlazoFijo, 'maxNumber:' + diasMaximoPlazoFijo, 'required', 'isNumber', 'isPositive']}
                                                    errorMessages={['Plazo minimo ' + diasMinimosPlazoFijo, 'Plazo maximo ' + diasMaximoPlazoFijo, 'El campo plazo es requerido', "Solo puedes ingresar numeros", "Solo puedes ingresar numeros"]}
                                                    fullWidth
                                                    id="plazo"
                                                    name="plazo"
                                                    label="Plazo en días"
                                                    helperText={"Mínimo " + diasMinimosPlazoFijo + " días."}
                                                    value={this.state.plazo}
                                                    onChange={this.handleChange}
                                                    InputLabelProps={{
                                                        className: classes.montoPlazoFechaLabel
                                                    }}
                                                    FormHelperTextProps={{
                                                        className: classes.montoPlazoFechaHelperText
                                                    }}
                                                    InputProps={{
                                                        className: classes.fechaLabel
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={11} md={6} className="input-simulacion">
                                                <MuiPickersUtilsProvider
                                                    utils={MomentUtils}
                                                    locale={this.state.locale}
                                                    moment={moment}
                                                >
                                                    <InlineDatePicker
                                                        error={errorPlazoFinDeSemana}
                                                        helperText={mensajeFechaFinDeSemana}
                                                        keyboard
                                                        className={classes.picker}
                                                        invalidDateMessage="El formato de la fecha es inválida"
                                                        minDateMessage={mensajePickerPlazoMinimo}
                                                        maxDateMessage={mensajePickerPlazoMaximo}
                                                        invalidLabel="El formato de la fecha es inválida"
                                                        shouldDisableDate={(event) => this.isWeekend(event)}
                                                        minDate={moment().add(diasMinimosPlazoFijo, 'days')}
                                                        maxDate={moment().add(diasMaximoPlazoFijo, 'days')}
                                                        onlyCalendar
                                                        label="Fecha"
                                                        format="DD/MM/YYYY"
                                                        disablePast={true}
                                                        value={this.state.plazoDias}
                                                        onChange={this.handleChangeDateParamThreshold(diasMinimosPlazoFijo,diasMaximoPlazoFijo)}
                                                        mask={value =>
                                                            value
                                                                ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]
                                                                : []
                                                        }       
                                                        InputLabelProps={{
                                                            shrink: true,
                                                            className: classes.montoPlazoFechaLabel
                                                        }}
                                                        InputProps={{
                                                            className: classes.fechaLabel
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={8} alignItems="flex-start"  justify="center"  className="form-container total" style={{ display: showDetalleUva }}>
                                            <Grid item xs={10}  md={5} className="totales">
                                                <Grid item xs={12} className={classes.interesAcobrarSimulacion + " interes-title " + classes.interesTnaMontoPadding}>
                                                    Cotización UVA
                                                </Grid>
                                                <Grid item xs={12} className={classes.textAlingL + " interes " + classes.interesTnaMontoPadding + "  " + classes.importesNumbers}>
                                                    ${this.state.cotizacionUva.toLocaleString()}
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={10}  md={5} className="totales">
                                                <Grid item xs={12} className={classes.interesAcobrarSimulacion + " interes-title " +  classes.interesTnaMontoPadding}>
                                                    Monto inicial en UVAs
                                                </Grid>
                                                <Grid item xs={12} className={classes.textAlingL + " monto " +  classes.interesTnaMontoPadding +  "  " + classes.importesNumbers}>
                                                    ${this.state.montoInicialUva.toLocaleString()}
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={8} alignItems="flex-start" justify="center" className="form-container total">
                                            <Grid item xs={10}  md={5} className="totales">
                                                <Grid item xs={12} className={classes.interesAcobrarSimulacion + " interes-title " + classes.interesTnaMontoPadding}>
                                                    Intereses a cobrar
                                                </Grid>
                                                <Grid item xs={12} className={classes.textAlingL + " interes " + classes.interesTnaMontoPadding + "  " + classes.importesNumbers}>
                                                    ${this.state.interes.toLocaleString()}
                                                </Grid>
                                                <Grid item xs={12} className={classes.textAlingL + " tna " +  classes.interesTnaMontoPadding + " " + classes.tnaSize}>
                                                    TNA {this.state.tna.toLocaleString()}%
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={10} md={5} className="totales">
                                                <Grid item xs={12} className={classes.interesAcobrarSimulacion + " interes-title " +  classes.interesTnaMontoPadding}>
                                                    Monto al vencimiento
                                                </Grid>
                                                <Grid item xs={12} className={classes.textAlingL + " monto " +  classes.interesTnaMontoPadding +  "  " + classes.importesNumbers}>
                                                    ${this.state.capital.toLocaleString()}
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={10} md={11} className={classes.textAlingL + " monto-title " + classes.simularPadding}>
                                                <Button type="submit" disabled={toDisabledSimular} className={classes.simular} name="action">Simular</Button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </CardContent>
                            </ValidatorForm>
                        </Card>
                    </Grid>
                    <Grid item xs={12} className="simulacion-info">
                        <Grid container className={classes.info + " info-simulacion-footer"}  >
                            <Grid item xs={1} className={classes.textAlign}>
                                <Info />
                            </Grid>
                            <Grid item xs={11} >
                                Si ya sos cliente deberás ingresar desde tu <span className={classes.redireccionar} onClick={this.redireccionarHomeBanking}>HomeBanking</span> o desde la <span>App</span> del Banco Hipotecario.
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.open}
                    autoHideDuration={3000}
                    onClose={this.handleClose}
                >
                    <SnackbarContentWrapper
                        onClose={this.handleClose}
                        variant="error"
                        message="Ups… algo falló."
                    />
                </Snackbar>
            </div>
        );
    }
}

//THEME
const styles = theme => ({
    card: {
        minWidth: "50%",
        margin: "auto",
        width: "80%",
        borderRadius: "20px",
        padding: "20px",
    },
    info: {
        minWidth: "50%",
        margin: "auto",
        width: "70%",
        fontSize: "16px"
    },
    margin: {
        margin: theme.spacing.unit,
        marginBottom: "-20px"
    },
    redireccionar: {
        cursor: 'pointer'
    },
    iconmatch: {
        marginBottom: "12px"
    },
    simular: {
        width: "94px",
        height: "25px",
        fontFamily: "Roboto",
        fontSize: "18px",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "left",
        color: "#f37320"
    },
    fechaVenc: {
        color: "rgba(0,0,0,0.54)",
    },
    textAlign: {
        textAlign: "center"
    },
    textAlingL: {
        textAlign: "left"
    },
    interesAcobrarSimulacion: {
        textAlign: "left"
    },
    fechaVencimiento: {
        paddingLeft: "1%"
    },
    montoPlazoFechaLabel: {
        fontSize: "16px",
        color: "#9b9b9b !important"
    },

    fechaLabel: {
        fontSize: "20px",
        color: "#4a4a4a"
    }

    ,
    montoPlazoHelperText: {
        opacity: "0.7",
        fontSize: "16px",
        color: "#9b9b9b"
    },
    montoPlazoFechaHelperText: {
        opacity: "0.7",
        fontSize: "12px",
        color: "#9b9b9b"
    },
    picker: {
        width: "100% !important"
    },
    interesTnaMontoPadding: {
        paddingLeft: "4%"
    },
    simularPadding: {
        paddingLeft: "5% !important"
    },
    importesNumbers: {
        fontSize: "30px !important"
    },
    tnaSize: {
        fontSize: "16px !important"
    },
    calendarIconCenter: {
        marginTop: "30px"
    },
    '@media  screen and (max-width: 959px)': {
        picker: {
            marginLeft: "9%"
        },
        interesTnaMontoPadding: {
            paddingLeft: "3% !important"
        },
        simularPadding: {
            paddingLeft: "1% !important"
        }
    }
});

const mapStateToProps = (state)=>{
    return ({
      dataLanding: state.plazoFijoLandingPage
  });
}

export default connect(mapStateToProps)( withRouter( withStyles(styles)(Simulacion)));



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/landingPage/Simulacion.js